// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-nX9xj";
var _3 = "date-3Pem4";
export { _1 as "__esModule", _2 as "root", _3 as "date" }
export default { "__esModule": _1, "root": _2, "date": _3 }
